import Icon from "@material-ui/icons/Explore";
import List from "./RoutePlanList";
import Create from "./RoutePlanCreate";
import Edit from "./RoutePlanEdit";
import Show from "./RoutePlanShow";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "busSchedulePlans",
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  icon: Icon,
};
